import { mapValues, merge } from "lodash";
function fixLineHeight(obj) {
  return {
    ...mapValues(obj, (value) => {
      return typeof value === "object" && value !== null ? fixLineHeight(value) : value;
    }),
    ...obj.fontSize !== void 0 && obj.lineHeight === void 0 ? { lineHeight: 1.5 } : {}
  };
}
function toVars(customStyles, prefix = "", separator = "-") {
  const propertyNames = {};
  function traverseObject(currentObj, currentPath = "") {
    for (const [key, value] of Object.entries(currentObj)) {
      const fullPath = currentPath ? `${currentPath}${separator}${key}` : key;
      if (typeof value === "object") {
        traverseObject(value, fullPath);
      } else {
        propertyNames[`${prefix ? prefix + "-" : ""}${fullPath}`] = value;
      }
    }
  }
  traverseObject(customStyles);
  return propertyNames;
}
const createCustomStyles = ({
  customStyles = {},
  settingsStyles = {},
  nativeStyle = {}
}) => {
  return merge(
    {},
    toVars(fixLineHeight(customStyles), "custom"),
    toVars(settingsStyles, "settings"),
    toVars(nativeStyle, "native")
  );
};
var customStyles_default = createCustomStyles;
export {
  customStyles_default as default,
  fixLineHeight
};
//# sourceMappingURL=customStyles.js.map
